export default {
  async registerTaskAsync(taskName: string): Promise<null> {
    return null;
  },
  async unregisterTaskAsync(taskName: string): Promise<null> {
    return null;
  },
};
